









































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import {IAllowBlockList} from '../shared/services/models/AllowBlockList';
import APIService from '../services/api';
import { IAccessControl } from '../shared/services/models/AccessControl';

// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        AllowBlockListComponent : require('@/shared/components/AllowBlockList').default,
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['allowBlockLists', 'accessControl']),
    },
    methods: {
        ...mapActions(['updateAllowBlockLists', 'saveAllowBlockList', 'addAllowBlockList', 'deleteAllowBlockList', 'updateAccessControl', 'saveAccessControl', 'addAccessControl', 'deleteAccessControl']),
    },
})
export default class AllowBlockList extends Vue {
    private allowBlockLists!: IAllowBlockList[];
    private accessControl!: IAccessControl[];
    private updateHandle: number = 0;
    private allowBlocklistListName: string = '';
    private username: string = '';
    private resourceName: string = '';
    private passphrase: string = '';

    private get AllowBlockLists(): IAllowBlockList[] {
        if (this.allowBlockLists !== null) {
            return this.allowBlockLists;
        }

        return [];
    }

    private get AccessControl(): IAccessControl[] {
        if (this.accessControl !== null) {
            return this.accessControl;
        }

        return [];
    }

    private mounted() {
        // @ts-ignore
        this.updateAllowBlockLists();
         // @ts-ignore
        this.updateAccessControl();
        // @ts-ignore
        /*this.updateHandle = setInterval(() => {
                // @ts-ignore
                this.updateAllowBlockLists();
        }, 60000);*/
    }

    private addAllowBlockListModal(): void {
        // @ts-ignore
        this.$bvModal.show('modal-add-allowBlocklist');
    }

    private addAllowBlockSave(): void {
        const pl: IAllowBlockList = {
            id: '',
            name: this.allowBlocklistListName,
            allow: [],
            block: [],
            descriptions: [],
        };
        // @ts-ignore
        this.addAllowBlockList(pl);
        setTimeout(() => {
            // @ts-ignore
            this.updateAllowBlockLists();
            this.allowBlocklistListName = '';
        }, 500);
    }

    private async save(allowBlockList: IAllowBlockList) {
        // console.log('allowBlockList', allowBlockList);
        // @ts-ignore
        this.saveAllowBlockList(allowBlockList);
        // @ts-ignore
        this.updateAllowBlockLists();
    }

    private addUserModal(): void {
        // @ts-ignore
        this.$bvModal.show('modal-add-accessList');
    }

    private addUserSave(): void {
        const pl: IAccessControl = {
            id: '',
            username: this.username,
            resource: this.resourceName,
            passphrase: this.passphrase,
        };
        // @ts-ignore
        this.addAccessControl(pl);
        setTimeout(() => {
            // @ts-ignore
            this.updateAccessControl();
            this.username = '';
            this.resourceName = '';
            this.passphrase = '';
        }, 500);
    }

    private async saveUser(accessControl: IAccessControl) {
        // console.log('allowBlockList', allowBlockList);
        // @ts-ignore
        this.saveAccessControl(accessControl);
        // @ts-ignore
        // this.updateAccessControl();
    }

    private remove(allowBlockList: IAllowBlockList) {
        APIService.DeleteAllowBlockList(allowBlockList);
        // @ts-ignore
        this.updateAllowBlockLists();
    }

    private removeUser(accessControl: IAccessControl) {
        APIService.DeleteAccessControl(accessControl);
        // @ts-ignore
        this.updateAccessControl();
    }

    private add() {
        // console.log('allowBlockList', allowBlockList);
        // @ts-ignore
        this.addAllowBlockList();
        // @ts-ignore
        this.updateAllowBlockLists();
    }

     private addUser() {
        // console.log('allowBlockList', allowBlockList);
        // @ts-ignore
        this.addAccessControl();
        // @ts-ignore
        this.updateAccessControl();
    }

    private destroyed() {
          //  clearInterval(this.updateHandle);
    }
}
